"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TooltipAction = function TooltipAction() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_style.Tooltip, null), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      width: '10px',
      margin: '0 auto',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react["default"].createElement(_style.Round, null), /*#__PURE__*/_react["default"].createElement(_style.Bang, null)));
};

var _default = TooltipAction;
exports["default"] = _default;